import React from 'react';
import { isEmpty } from 'lodash';

import { useStyles } from '~/assets/styles';
import EmptyState from '~/components/core/EmptyState';
import InternalAdminStripe from '~/components/Stripe/InternalAdmin';
import InternalAdminVitesse from '~/components/Vitesse/InternalAdmin';
import { isLocaleRegionIsUs } from '~/Utils/regionUtils';

import CardDialog from '../../../CardDialog';
import InnerTabs from '../../../core/Layout/InnerTabs/InnerTabs';
import InternalAdminCCCWrapper from '../CCC/InternalAdmin';
import InternalAdminClaimSearchWrapper from '../ClaimSearch/InternalAdmin';
import InternalAdminESignWrapper from '../ESignConfiguration';
import InternalAdminGbgWrapper from '../GBG';
import InternalAdminN8nWrapper from '../N8nConfiguration';
import InternalAdminNavigatorWrapper from '../Navigator/InternalAdmin';
import InternalAdminOneIncWrapper from '../OneInc/InternalAdmin';
import InternalAdminXactAnalysisWrapper from '../XactAnalysis/InternalAdmin';

const IntegrationTab = () => {
  const { classes } = useStyles();

  const tabs = [
    {
      label: 'Navigator',
      url: 'navigator',
      isTabHidden: !isLocaleRegionIsUs(),
      component: InternalAdminNavigatorWrapper,
      props: {},
    },
    {
      label: 'ClaimSearch',
      url: 'claim_search',
      isTabHidden: !isLocaleRegionIsUs(),
      component: InternalAdminClaimSearchWrapper,
      props: {},
    },
    {
      label: 'XactAnalysis',
      url: 'xactanalysis',
      isTabHidden: !isLocaleRegionIsUs(),
      component: InternalAdminXactAnalysisWrapper,
      props: {},
    },
    {
      label: 'One Inc',
      url: 'one-inc',
      isTabHidden: !isLocaleRegionIsUs(),
      component: InternalAdminOneIncWrapper,
      props: {},
    },
    {
      label: 'Vitesse',
      url: 'vitesse',
      component: InternalAdminVitesse,
      props: {},
    },
    {
      label: 'Stripe',
      url: 'stripe',
      component: InternalAdminStripe,
      props: {},
    },
    {
      label: 'N8N',
      url: 'n8n',
      component: InternalAdminN8nWrapper,
      props: {},
    },
    {
      label: 'E-Sign',
      url: 'e_sign',
      component: InternalAdminESignWrapper,
      props: {},
    },
    {
      label: 'CCC',
      url: 'ccc',
      isTabHidden: !isLocaleRegionIsUs(),
      component: InternalAdminCCCWrapper,
      props: {},
    },
    {
      label: 'GBG',
      url: 'gbg',
      component: InternalAdminGbgWrapper,
      props: {},
    },
  ];

  const availableTabs = tabs.filter((tab) => !tab.isTabHidden);
  availableTabs.sort((a, b) => (a.label > b.label ? 1 : -1));

  return (
    <div className={classes.cardDiv}>
      <CardDialog title="Integrations">
        <div className={classes.cardDivRow}>
          {isEmpty(availableTabs) ? (
            <EmptyState title="No Available Integrations" />
          ) : (
            <InnerTabs tabs={availableTabs} />
          )}
        </div>
      </CardDialog>
    </div>
  );
};

export default IntegrationTab;
